/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToggleChildren/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ToggleChildren({
  children,
  viewPath = "/DesignSystem/ToggleChildren",
  backgroundColor = "rgba(111,111,111, 0.05)",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  marginTop = 0,
  marginRight = 0,
  marginLeft = 0,
  onClick,
  isDisabled,
  paddingTop = 8,
  paddingLeft = 8,
  paddingBottom = 8,
  paddingRight = 8,
  isSelected,
  backgroundColorSelected = "red",
  backgroundColorSelectedHovered = "red"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
  return (<React.Fragment
>
<button
  data-testid="ToggleChildren.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 disabled={isDisabled}
 style={{'--bblr-2-2tfwWL': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-2tfwWL': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-4-2tfwWL': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-5-2tfwWL': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--mt-6-2tfwWL': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-7-2tfwWL': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-8-2tfwWL': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--pt-9-2tfwWL': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pl-10-2tfwWL': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pb-11-2tfwWL': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pr-12-2tfwWL': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--bc-1-2tfwWL': isSelectedHovered ? backgroundColorSelectedHovered : isSelected ? backgroundColorSelected : isHovered ? "rgba(111,111,111, 0.1)" : backgroundColor}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</button>
</React.Fragment>)
}